import React, { useEffect, useState } from "react";
import LoginPage from "../LoginPage";
import DropBtn from "../modules/DropBtn";
import Button from "../modules/Button";
import { Route, Routes } from "react-router-dom";
import Source from "./Source";
import Verification from "./Verification";
import College from "./College";
import Income from "./Income";
import Nationality from "./Nationality";
import { useDispatch, useSelector } from "react-redux";
import { addCandidateInfo } from "./redux/actions";
import MobileVerification from "./Mobile";
import EmailVerification from "./Email";
import Success from "./Success";
import { resetTimerData } from "../IdfcLetterHead/redux/actions";

function Register() {
  const dispatch = useDispatch();

  const [value, setValue] = useState("");
  const [Link, setLink] = useState("");
  // const dispatch= useDispatch()

  const registeredData = useSelector((state) => state.register.registeredData);
  useEffect(() => {
  dispatch(resetTimerData())

    let currentUrl = window.location.href;
    // const url = new URL(currentUrl);
    // const baseUrl = `${url.protocol}//${url.host}`;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    // console.log("window", cleanedUrl.split("/")[0]);
    setLink(cleanedUrl);

    window.onload = function () {
      localStorage.clear();
    };
  }, []);

  console.log("in main", registeredData);
  return (
    <LoginPage>
      <Routes>
        <Route path="/" element={<Verification />} />
        <Route path="source" element={<Source />} />
        <Route path="college" element={<College />} />
        <Route path="income" element={<Income />} />
        <Route path="nationality" element={<Nationality />} />
        <Route path="mobile" element={<MobileVerification />} />
        <Route path="email" element={<EmailVerification />} />
        <Route path="success" element={<Success />} />

        <Route path="*" element={<Source />} /> 


      </Routes>
    </LoginPage>
  );
}

export default Register;
